var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0249 21.75C6.11703 21.75 1.30707 17.15 1.30707 11.5C1.30707 5.85 6.11703 1.25 12.0249 1.25C17.9328 1.25 22.7428 5.85 22.7428 11.5C22.7428 17.15 17.9328 21.75 12.0249 21.75ZM12.0249 2.75C6.97445 2.75 2.87553 6.68 2.87553 11.5C2.87553 16.32 6.97445 20.25 12.0249 20.25C17.0754 20.25 21.1743 16.32 21.1743 11.5C21.1743 6.68 17.0754 2.75 12.0249 2.75Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0046 22.7499C22.8059 22.7499 22.6072 22.6799 22.4504 22.5299L20.3591 20.5299C20.0558 20.2399 20.0558 19.7599 20.3591 19.4699C20.6623 19.1799 21.1642 19.1799 21.4675 19.4699L23.5588 21.4699C23.862 21.7599 23.862 22.2399 23.5588 22.5299C23.4019 22.6799 23.2032 22.7499 23.0046 22.7499Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.43b1bc6487b583ebdf370a190c8b09cc.svg";
export { ForwardRef as ReactComponent };